


































































































































































































































import { defineComponent, reactive, toRefs, ref, onMounted, watch, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http"
import moment from 'moment'
import * as Common from "../../commons/common"
import { BModal } from 'bootstrap-vue';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import AlertArea from "../../components/AlertArea.vue"
import PracticeSumupResultRankTab from "../../components/PracticeSumupResultRankTab.vue"
import { SumupGroup, SumupUnit, RankResult, Assessment, AssessmentScore, AssessmentExaminee, SearchCondtion, BaseAssessment } from "../../modules/teacher/PracticeSumupResultRankListTotal"

export interface Data {
  sumup_group_id: string
  condition: SearchCondtion
  sumupGroup: SumupGroup
  rankResults: RankResult[]
  rows: any[]
  filteredRankResults: RankResult[]
  additionTarget: RankResult
  assessments: Assessment[]
  sumupUnits: SumupUnit[]
  fields: any[]
  colNames: string[]
  isAllCheckedPublishing: boolean
  isAllCheckSumup: boolean
  errors: string[]
  assessmentColspan: number
  isDispAssessment: boolean
  modalErrors: string[]
  baseAssessments: BaseAssessment[]
}

export default defineComponent({
  components: {
    "practice-sumup-result-rank-tab": PracticeSumupResultRankTab,
    "alert-area": AlertArea,
    "date-time-picker" : VueCtkDateTimePicker,
  },
  setup(props, context){

    const additionModalRef = ref<InstanceType<typeof BModal>>();
    const assessmentModalRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_group_id: "",
      sumupGroup: null,
      condition: new SearchCondtion(),
      rankResults: [],
      rows: [],
      filteredRankResults: [],
      additionTarget: null,
      assessments: [],
      sumupUnits: [],
      fields: [],
      colNames: [],
      isAllCheckedPublishing: false,
      isAllCheckSumup: false,
      errors: new Array<string>(),
      assessmentColspan: null,
      isDispAssessment: false,
      modalErrors: [],
      baseAssessments: [],
    });

    /******************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ******************************/

    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");

      if(tableArea != null){
        tableArea.style.height = (winH - tableArea.offsetTop - 10) + "px";
      }
    };

    /******************************
     * 一覧のCSS
     ******************************/

    const colStyle = (key: string) => {
      
      const style: any = {}
      
      if(["student_no_character", "student_name"].includes(key)){
        style["min-width"] = "100px"
      }else if(["addition", "practice_examinee_id"].includes(key)){
        style["width"] = "60px";
      }else if(["isSelected", "result_published"].includes(key)){
        style["width"] = "80px";
      }else if(key.includes("score") || key.includes("rank")){
        style["width"] = "100px";
      }else if(key.includes("assessment")){
        style["min-width"] = "100px";
      }

      return style;
    }

    /******************************
     * 生徒成績TOP画面へ
     ******************************/

    const toResultTop = (practice_examinee_id: number) => {
      context.root.$store.commit("setPracticeExamineeId", practice_examinee_id);
      context.root.$router.push(`/teacher_site/practice_examinee_result_top`).catch(err => {});
    }

    /******************************
     * 集計列 ヘッダーチェックボックス
     ******************************/

    watch(() => state.isAllCheckSumup, (newVal, oldVal) => {
      state.filteredRankResults.forEach(x => x.isSelected = newVal);
    });

    /******************************
     * 公開列 ヘッダーチェックボックス
     ******************************/

    watch(() => state.isAllCheckedPublishing, (newVal, oldVal) => {
      state.filteredRankResults.forEach(x => x.result_published = newVal);
    });

    /******************************
     * 備考モーダル表示
     ******************************/

    const showAdditionModal = (student_no_character: string) => {
      state.additionTarget = state.rankResults.filter(x => x.student_no_character == student_no_character)[0];
      additionModalRef.value.show();
    }

    /******************************
     * 検索
     ******************************/

    const search = () => {
      let filteredRankResults = state.rankResults.map(x => x);
      if(state.condition.student_no_character){
        filteredRankResults = state.rankResults.filter(x => x.student_no_character == state.condition.student_no_character);
      }
      if(state.condition.student_name){
        filteredRankResults = filteredRankResults.filter(x => x.student_name.includes(state.condition.student_name));
      }
      filteredRankResults.forEach(x => {
        x.rowObject["result_published"] = x.result_published_cache;
        x.rowObject["isSelected"] = false;
      });
      state.filteredRankResults = filteredRankResults;
    }

    /******************************
     * クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondtion();
    }

    /******************************
     * 判定設定モーダル表示
     ******************************/

    const showAssessmentModal = () => {
      assessmentModalRef.value.show();
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "-";
    };

    /******************************
     * 一覧得点列のフォーマッター
     ******************************/

    const scoreFormatter = (value: any) => {
      return value == -1 ? "-" : `${value}点`;
    }

    /******************************
     * 一覧順位列のフォーマッター
     ******************************/

    const rankFormatter = (value: any) => {
      return value == 10000 ? "-" : `${value}位`;
    }

    /******************************
     * 一覧偏差値列のフォーマッター
     ******************************/

    const stdScoreFormatter = (value: any) => {
      return value == -1 ? "-" : `${value}`;
    }

    /******************************
     * 評価情報追加
     ******************************/

    const addAssessment = (assessment: Assessment) => {
      state.assessments.push(createEmptyAssessment());
    }

    /******************************
     * 評価情報削除
     ******************************/

    const deleteAssessment = (assessment: Assessment) => {
      const idx = state.assessments.indexOf(assessment);
      state.assessments.splice(idx, 1);
    }

    /******************************
     * 空の評価オブジェクト追加
     ******************************/

    const createEmptyAssessment = () => {
      const assessment = new Assessment(state.baseAssessments);
      return assessment;
    }

    /******************************
     * 判定更新ボタン押下
     ******************************/

    const updateAssessment = async () => {

      state.modalErrors = [];

      state.assessments.forEach((assessment, i) => {

        if(!assessment.name){
          state.modalErrors.push(`${i + 1}件目の名称が入力されていません。`);
        }

        if(!assessment.sumup_unit_id){
          state.modalErrors.push(`${i + 1}件目の判定に使用する集計が選択されていません。`);
        }

        if(assessment.assessment_scores.length < 2){
          state.modalErrors.push(`${i + 1}件目の判定情報が行数が不足しています。最低2行登録してください。`);
        }

        if(!assessment.sort_no){
          state.modalErrors.push(`${i + 1}件目の並び順が入力されていません。`);
        }else if(!Common.isFloatOrInteger(assessment.sort_no)){
          state.modalErrors.push(`${i + 1}件目の並び順に数字以外が入力されています。`);
        }

        assessment.assessment_scores.forEach((assessment_score, j) => {
          if(!assessment_score.name){
            state.modalErrors.push(`${i + 1}件目の${j + 1}行目の判定名が入力されていません。`);
          }

          if(j + 1 == assessment.assessment_scores.length){
            return;
          }

          if(assessment.is_gender_separate){
            if(!assessment_score.man_score || !assessment_score.woman_score){
              state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値が入力されていません。`);
            }else if(!Common.isFloatOrInteger(assessment_score.man_score) || !Common.isFloatOrInteger(assessment_score.woman_score)){
              state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値に数字以外が入力されています。`);
            }else{
              if(j != 0 && j != assessment.assessment_scores.length - 1){
                if(Number(assessment_score.man_score) >= Number(assessment.assessment_scores[j - 1].man_score) || Number(assessment_score.woman_score) >= Number(assessment.assessment_scores[j - 1].woman_score)){
                  state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値が高い順に入力されていません。`);
                }
              }
            }
          }else{
            if(!assessment_score.total_score){
              state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値が入力されていません。`);
            }else if(!Common.isFloatOrInteger(assessment_score.total_score)){
              state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値に数字以外が入力されています。`);
            }else{
              if(j != 0 && j != assessment.assessment_scores.length - 1){
                if(Number(assessment_score.total_score) >= Number(assessment.assessment_scores[j - 1].total_score)){
                  state.modalErrors.push(`${i + 1}件目の${j + 1}行目の閾値が高い順に入力されていません。`);
                }
              }
            }
          }
        });
      });

      if(state.modalErrors.length > 0){
        return;
      }
      
      if (!window.confirm('判定を変更します。よろしいですか？')) {
        return;
      }

      const params = {
        assessments: state.assessments
      };

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_result_rank_list_total/update_assessment/${state.sumup_group_id}`, params).then(response => {
        alert("処理が完了しました。");
        
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");

    }

    /******************************
     * 公開予約更新
     ******************************/

    const updateResultPublishSchedule = async () => {
      
      state.errors = [];

      if(!window.confirm("公開予約を登録します。よろしいですか？")){
        return;
      }

      const param = {
        result_publish_start_datetime_at: state.sumupGroup.result_publish_start_datetime_at,
        result_publish_end_datetime_at: state.sumupGroup.result_publish_end_datetime_at,
      };

      await http.post(`/api/teacher/practice_sumup_result_rank_list_total/update_result_publish_schedule/${state.sumupGroup.id}`, param).then(response => {
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 公開変更ボタン押下
     ******************************/

    const updatePublished = async () => {

      if (!window.confirm('公開状態を変更します。よろしいですか？')) {
        return;
      }

      const examinees: any = [];
      state.filteredRankResults.forEach(x => examinees.push({student_no_character: x.student_no_character, result_published: x.result_published}));

      if(examinees.length == 0){
        state.errors.push("対象の受験者が存在しません。");
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_result_rank_list_total/update_published/${state.sumup_group_id}`, {examinees: examinees}).then(response => {
        alert("処理が完了しました。");
        
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 個別集計ボタン押下
     ******************************/

    const sumup = async () => {

      let practice_examinee_ids: any = [];
      practice_examinee_ids = state.filteredRankResults.filter(x => x.isSelected).map(x => x.practice_examinee_id);

      if(practice_examinee_ids.length == 0){
        state.errors.push("対象の受験者が選択されていません。");
        return;
      }

      if (!window.confirm('選択している受験者の個別集計を行います。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_result_rank_list_total/sumup/${state.sumup_group_id}`, {"practice_examinee_ids": practice_examinee_ids}).then(response => {
        alert("処理が完了しました。");
        
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }
    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      //context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      await http.get(`/api/teacher/practice_sumup_result_rank_list_total?sumup_group_id=${state.sumup_group_id}`).then(response => {
        
        state.sumupGroup = new SumupGroup(response.data.sumup_group);
        state.rankResults = response.data.rank_results.map((x: any) => new RankResult(x));
        state.sumupUnits = response.data.sumup_units.map((x: any) => new SumupUnit(x));
        state.baseAssessments = response.data.base_assessments.map((x: any) => new BaseAssessment(x));
        state.assessments = response.data.assessments.map((x: any) => new Assessment(state.baseAssessments, x, response.data.assessment_scores));
        const assessment_examinees: AssessmentExaminee[] = response.data.assessment_examinees.map((x: any) => new AssessmentExaminee(x));

        state.fields.push({key: "student_no_character", label: "受験番号", sortable: true, class: 'text-center b-table-th-td'});
        state.fields.push({key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'});
        state.fields.push({key: "gender", label: "性別", sortable: true, class: 'text-center b-table-th-td'});
        state.fields.push({key: "addition", label: "備考", sortable: false, class: 'text-center b-table-th-td'});
        state.fields.push({key: "practice_examinee_id", label: "成績", sortable: false, class: 'text-center b-table-th-td'});

        state.sumupUnits.forEach((sumupUnit, i) => {
          const score_key = `total_score_${sumupUnit.id}`;
          const std_score_key = `total_std_score_${sumupUnit.id}`;
          const rank_key = `total_rank_${sumupUnit.id}`;

          state.fields.push({key: score_key, label: "得点", sortable: true, class: 'text-center b-table-th-td', formatter: 'scoreFormatter'});
          state.fields.push({key: rank_key, label: "順位", sortable: true, class: 'text-center b-table-th-td', formatter: 'rankFormatter'});
          state.fields.push({key: std_score_key, label: "偏差値", sortable: true, class: 'text-center b-table-th-td', formatter: 'stdScoreFormatter'});

          state.rankResults.forEach(rankResult => {
            // @ts-ignore
            rankResult[score_key] = rankResult.sumupUnitResults[i].score;
            // @ts-ignore
            rankResult[std_score_key] = rankResult.sumupUnitResults[i].total_std_score;
            // @ts-ignore
            rankResult[rank_key] = rankResult.sumupUnitResults[i].total_rank;
          });
        });

        state.assessments.forEach(assessment => {
          const key = `assessment_${assessment.id}`;
          state.fields.push({key: key, label: assessment.name, sortable: false, class: 'text-center b-table-th-td'});

          state.rankResults.forEach(rankResult => {
            const assessment_examinee = assessment_examinees.filter(x => x.practice_examinee_id == rankResult.practice_examinee_id && x.assessment_id == assessment.id);
            let value = "-";
            if(assessment_examinee.length > 0){
              const assessment_score = assessment.assessment_scores.filter(x => x.id == assessment_examinee[0].assessment_score_id);
              if(assessment_score.length > 0){
                const base_assessment = state.baseAssessments.filter(x => x.id == assessment_score[0].base_assessment_id);
                if(base_assessment.length > 0){
                  value = base_assessment[0].name;
                }
              }
            }
            // @ts-ignore
            rankResult[key] = value;
          });
        });

        state.fields.push({key: "isSelected", label: "再集計", sortable: false, class: 'text-center b-table-th-td'});
        state.fields.push({key: "result_published", label: "公開", sortable: false, class: 'text-center b-table-th-td'});

        state.assessmentColspan = state.assessments.length;
        state.isDispAssessment = state.assessments.length > 0;

        search();
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      document.body.style.overflow = "hidden";

      context.root.$store.dispatch("hideOverlay");
    });

    /************************************************************
     * before unmount windowイベント解除・排他制御解除
     ************************************************************/
    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      document.body.style.overflow = "";
    });

    return {
      ...toRefs(state),
      additionModalRef,
      assessmentModalRef,
      convertExecDate,
      scoreFormatter,
      rankFormatter,
      stdScoreFormatter,
      showAdditionModal,
      showAssessmentModal,
      updatePublished,
      search,
      clearCondition,
      sumup,
      addAssessment,
      deleteAssessment,
      updateAssessment,
      colStyle,
      toResultTop,
      updateResultPublishSchedule,
    };
  }
});
